import { LoadingView } from '../../../components/LoadingView';
import { Table } from '../../../components/Table';
import { useTopCountriesQuery } from '../../../features/company/useTopCountriesQuery';
import { useDispatchTrackEventWithLocation } from '../../../services/tracking/hooks/useDispatchTrackEventWithLocation';
import { NoDataView, NoDataViewVariant } from '../NoDataView';

import { CountryShareTableRow } from './CountryShareTableRow';

const COUNTRY_SHARE_TABLE_HEADER_CONFIG = [
  { translateKey: 'company.traffic_share.countries' },
  { translateKey: 'company.traffic_share.share', width: '130px' },
];

export const CountryShareView = () => {
  const dispatchTrackEventWithLocation = useDispatchTrackEventWithLocation();
  const { data: topCountries, isLoading, isError } = useTopCountriesQuery();

  if (isLoading) {
    return <LoadingView />;
  }

  if (isError || !topCountries || topCountries.countries.length === 0) {
    return <NoDataView variant={NoDataViewVariant.trafficShare} />;
  }

  const onPageChange = (page: number) => {
    dispatchTrackEventWithLocation(
      'company data',
      'change page',
      `traffic share countries/${topCountries.countries.length}/${page}`
    );
  };

  return (
    <Table
      keyProperty="country"
      data={topCountries.countries}
      headerConfig={COUNTRY_SHARE_TABLE_HEADER_CONFIG}
      RowComponent={CountryShareTableRow}
      onPageChange={onPageChange}
    />
  );
};
